const img = require('./BaseOption.svg'); export default img;